import type { New } from '@/domain/base';
import type { Lead } from '@/domain/leads';
import { api } from '@/utils/configuration';
import { crudService } from '@/utils/request';

export const LeadService = {
  create: (communityId: number, lead: Omit<New<Lead>, 'personId'>) =>
    crudService.post<Lead>(lead, `${api.COMMUNITIES}/${communityId}/leads`),
};
